import { useCopyAPIKeyIntegration } from "../CopyAPIKeyModal/useCopyAPIKeyIntegration";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import levvyLogoUrl from "./levvy-logo.png";
import { jsx as _jsx } from "react/jsx-runtime";
export default function LevvyCard() {
  const {
    showCopyAPIKeyModal
  } = useCopyAPIKeyIntegration('levvy');
  return /*#__PURE__*/_jsx(IntegrationCard, {
    "data-testid": "levvy-card",
    icon: /*#__PURE__*/_jsx(IntegrationCard.LogoImg, {
      alt: "Levvy logo",
      src: levvyLogoUrl
    }),
    title: "Levvy",
    subTitle: "Integrate with Levvy to automate client setup and workflow creation",
    mainAction: /*#__PURE__*/_jsx(IntegrationCard.MainActionButton, {
      onClick: showCopyAPIKeyModal,
      "data-testid": "levvy-card-connect",
      children: "Connect"
    })
  });
}